/**
 * Procedure Consent Form — uses the consent template system with
 * surgery-specific clauses.
 *
 * The consent text ends with a fill-in field for the procedure name.
 */
import { Text, View } from '@react-pdf/renderer'

import { FillField } from '@/frontend/features/printing/documents/blocks/pdf-fields'
import {
  ANAESTHESIA_RISK_CLAUSE,
  DISCHARGE_TIME_CLAUSE,
  EMERGENCY_AUTH_CLAUSE,
  IV_FLUIDS_CLAUSE,
} from '@/frontend/features/printing/documents/consent/clauses'
import { buildPreOpConsentForm } from '@/frontend/features/printing/documents/consent/consent-template.form'
import { mm } from '@/frontend/features/printing/pdf-utils'

const consentText = (name: string) =>
  `I am the owner or authorised agent for the owner of ${name}. I give my consent for Snoots to perform a`

const SURGERY_FINDINGS_CLAUSE = (patientName: string) =>
  `I understand that ${patientName} will be having a surgical procedure today based on the findings at the consultation with the vet`

const SURGERY_COST_CLAUSE =
  'I understand that this cost of this procedure will be £399 or £599, with an additional £150 for histopathology should this be chosen to send off'

const SURGERY_ADVANCED_CLAUSE =
  'Should the procedure be more advanced than additionally thought, I understand the price may change but the vet will call me to discuss this.'

const SURGERY_RISK_CLAUSE =
  'I have been advised that surgical procedures always involves risk. Rare but possible completions include wound breakdown & infection.'

const POST_OP_RESPONSIBILITY_CLAUSE =
  'I understand that I am responsible for following post-operative instructions and administering any medications provided. Failure to follow instructions may result in complications such as wound breakdown or infection.'

function SurgeryConsentPreview({ patientName }: { patientName: string }) {
  return (
    <div>
      <p>{consentText(patientName)}</p>
      <p className="mt-1 border-b border-muted-foreground pb-1">&nbsp;</p>
    </div>
  )
}

function SurgeryConsentPrint({ patientName }: { patientName: string }) {
  return (
    <View>
      <Text style={{ fontSize: 10 }}>{consentText(patientName)}</Text>
      <View style={{ marginTop: mm(2) }}>
        <FillField />
      </View>
    </View>
  )
}

export const surgeryConsent = buildPreOpConsentForm({
  id: 'surgery-consent',
  label: 'Procedure Consent Form',
  title: 'PROCEDURE CONSENT FORM',
  renderConsentPreview: SurgeryConsentPreview,
  renderConsentPrint: SurgeryConsentPrint,
  clauses: [
    SURGERY_FINDINGS_CLAUSE,
    SURGERY_COST_CLAUSE,
    SURGERY_ADVANCED_CLAUSE,
    ANAESTHESIA_RISK_CLAUSE,
    SURGERY_RISK_CLAUSE,
    POST_OP_RESPONSIBILITY_CLAUSE,
    EMERGENCY_AUTH_CLAUSE,
    IV_FLUIDS_CLAUSE,
    DISCHARGE_TIME_CLAUSE,
  ],
})
